import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

declare global {
  interface Window { 
    clarity?: (...args: any[]) => void;
  }
}

export const useInitClarity = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    if (typeof window === 'undefined') return;
    if (window.location.pathname.includes('/admin')) return;

    const init = async () => {
      try {
        const { data } = await supabase
          .from('pixels')
          .select('clarity_project_id')
          .eq('platform', 'clarity')
          .eq('is_active', true)
          .maybeSingle();

        const projectId = data?.clarity_project_id;
        if (!projectId) return;

        // Load Clarity script
        (function(c: any, l: any, a: string, r: string, i: string, t?: any, y?: any) {
          c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments); };
          t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", projectId);

        initialized.current = true;
        console.log('Microsoft Clarity initialized:', projectId);
      } catch (e) {
        console.error('Clarity init error:', e);
      }
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => init(), { timeout: 5000 });
    } else {
      setTimeout(() => init(), 3000);
    }
  }, []);
};
